module.exports = ".ssf-close {\n  color: #696969;\n  cursor: pointer; }\n  .ssf-close:hover {\n    font-weight: bold; }\n\n.ssf-close__text {\n  text-transform: uppercase; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/components/close-button/close-button.component.scss
// module id = 803
// module chunks = 3